import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=4770481c&scoped=true"
import script from "./SearchPanel.vue?vue&type=script&lang=js"
export * from "./SearchPanel.vue?vue&type=script&lang=js"
import style0 from "./SearchPanel.vue?vue&type=style&index=0&id=4770481c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770481c",
  null
  
)

export default component.exports